import * as React from "react";
import { IProductModel } from "../../models";
import { useAppState } from "../../containers";
import { ProductContainer } from "..";

import { useState } from "react";
import classNames from "classnames";
import { Button } from "../../atoms";

import "./cart.scss";
import { useThemedAsset } from "../../hooks/use-themed-asset";

interface ICartProps {
  selectedProduct?: IProductModel;
}
const Cart: React.FC<ICartProps> = ({ selectedProduct }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerUrl = useThemedAsset("/images/{theme}/shop/go-to-cart.svg");

  const baseClassName = "cart";
  const className = classNames(baseClassName, {
    "is-active": isOpen
  });

  const renderCart =
    selectedProduct &&
    selectedProduct.selectedSize &&
    selectedProduct.selectedSize.length > 0;

  const triggerButtonClassName = classNames(`${baseClassName}__trigger`, {
    "is-visible": renderCart
  });

  return (
    <>
      {renderCart && (
        <div className={className}>
          <h2>Ovo ti se sviđa? A da pogledaš još malo</h2>
          <ProductContainer
            product={selectedProduct as IProductModel}
            showActions={false}
            showSelectedSize={true}
          />

          <form
            action="/success"
            name="order"
            method="post"
            data-netlify={true}
          >
            <input
              type="hidden"
              name="name"
              value={(selectedProduct as IProductModel).name}
            />
            <input
              type="hidden"
              name="url"
              value={(selectedProduct as IProductModel).url}
            />
            <input
              type="hidden"
              name="size"
              value={(selectedProduct as IProductModel).selectedSize}
            />
            <input type="hidden" name="form-name" value="order" />

            <Button theme="primary" type="submit">
              Evo ti dukata, daj mi moj duks!
            </Button>
          </form>
        </div>
      )}

      <Button
        className={triggerButtonClassName}
        theme="primary"
        onClick={() => setIsOpen(!isOpen)}
        title="Pogledaj korpu"
      >
        <img src={triggerUrl} alt="" />
      </Button>
    </>
  );
};

export const CartContainer: React.FC = () => {
  const { selectedProduct = undefined } = useAppState();

  return <Cart selectedProduct={selectedProduct} />;
};
